// pages/Dashboard.jsx
import DashboardLayout from "../../components/dashboard/DashboardLayout";
import SubscribedUsers from "../../components/dashboard/SubscribedUsers";

export default function Dashboard() {
  return (
    <DashboardLayout>
      <SubscribedUsers />
    </DashboardLayout>
  );
}
